import { render, staticRenderFns } from "./FeCurrency.vue?vue&type=template&id=3be8f862&scoped=true&"
import script from "./FeCurrency.vue?vue&type=script&lang=js&"
export * from "./FeCurrency.vue?vue&type=script&lang=js&"
import style0 from "./FeCurrency.vue?vue&type=style&index=0&id=3be8f862&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be8f862",
  null
  
)

export default component.exports